import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Grid,
  Typography
} from '@material-ui/core';
import { ThemeProvider, makeStyles } from '@material-ui/styles';
import { createTheme } from '@mui/material';
import { Layout } from 'antd';
import { useEffect, useState } from 'react';
import { ReactComponent as Mastercard } from '../../asset/svg/paymentCardType/mastercard.svg';
import { ReactComponent as Visa } from '../../asset/svg/paymentCardType/visa.svg';
import CButton from '../Button';

const theme = createTheme({
  overrides: {
    MuiTypography: {
      root: {
        '& span.addNew': {
          color: '#6E7191',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '24px',
          textAlign: 'center'
        },

        '& span.span1': {
          display: 'block',
          fontSize: '24px',
          fontWeight: '600',
          lineHeight: '32px',
          textAlign: 'left'
        },
        '& span.span2': {
          color: '#6E7191',
          display: 'block',
          fontSize: '16px',
          fontWeight: '400',
          lineHeight: '24px',
          textAlign: 'left'
        }
      }
    }
  }
});

const useStyles = makeStyles({
  noPointers: {
    pointerEvents: 'none' // removing hover effect on parts of card
  },
  selectedAcc: {
    border: '2px solid #5564F8 !important',
    outline: 'none !important'
  }
});

const PaymentGrid = ({ data = [], updateSelected, updateSelectedId }) => {
  const [values, setValues] = useState(data);
  const classes = useStyles();
  const [selected, setSelected] = useState(null);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    setValues(data);
  }, [data, setValues]);

  const selectAcc = (id, e) => {
    // resetting selected account
    if (selected) {
      selected.classList.remove(classes.selectedAcc);
      setSelected(null);
    }
    if (selectedId) {
      setSelectedId(null);
    }

    setSelected(e.target);
    setSelectedId(id);
    e.target.classList.add(classes.selectedAcc);
  };

  const unSelectAcc = (e) => {
    e.target.classList.remove(classes.selectedAcc);
  };

  useEffect(() => {
    updateSelected(selected);
  }, [selected]);

  useEffect(() => {
    updateSelectedId(selectedId);
  }, [selectedId]);

  return (
    <Layout
      style={{
        backgroundColor: '#FFF',
        paddingLeft: '24px',
        paddingRight: '24px'
      }}
    >
      <Grid
        alignItems="flex-start"
        container
        direction="row"
        justify="flex-start"
        spacing={3}
        style={{
          maxWidth: '1250px'
        }}
      >
        {values.map((d) => (
          <Grid key={d.id} container item xs={4}>
            <Card
              onBlur={(e) => unSelectAcc(e)}
              onClick={(e) => selectAcc(d.id, e)}
              style={{
                backgroundColor: '#FCFCFC',
                border: '1px solid #CAD8FF',
                borderRadius: '10px',
                boxShadow: '0',
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                height: '228px',
                padding: '24px',
                radius: '8px',
                width: '363px'
              }}
              tabIndex="0"
            >
              <CardActions
                className={classes.noPointers}
                style={{
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  justifyContent: 'space-between',
                  padding: '0'
                }}
              >
                <div
                  style={{
                    height: '32px',
                    justifySelf: 'flex-end',
                    width: '58px'
                  }}
                >
                  {d.type?.toLowerCase() === 'mastercard' ? <Mastercard /> : <Visa />}
                </div>

                <CButton
                  style={{
                    borderColor: '#5564F8',
                    borderRadius: '8px',
                    color: '#5564F8',
                    margin: '0px',
                    visibility: `${d.default ? 'visible' : 'hidden'}`
                  }}
                >
                  Default
                </CButton>
              </CardActions>

              <CardActionArea
                className={classes.noPointers}
                style={{
                  alignItems: 'flex-end',
                  display: 'flex',
                  flexGrow: '2',
                  justifyContent: 'flex-start'
                }}
              >
                <CardContent
                  style={{
                    padding: '0'
                  }}
                >
                  <ThemeProvider theme={theme}>
                    <Typography>
                      <span className="span1">
                        {`${d.type.charAt(0).toUpperCase() + d.type.slice(1)} **** 
                      ${d.accNum.substring(d.accNum.length - 4, d.accNum.length)}`}
                      </span>
                      <span className="span2">{`Expires ${d.expires}`}</span>
                    </Typography>
                  </ThemeProvider>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
        {/* <Grid container item key={data.legth + 1} xs={4}>
          <Card style={{
                width: "363px",
                height: "228px",
                radius: "8px",
                backgroundColor: "rgb(239, 240, 247)",
                boxShadow: "unset",
                border: "2px dashed #D6D8E7",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
            onClick={navigate}>
            <CardActionArea
              style={{
                height: "100%",
              }}>
              <CardContent>
                <div
                  style={{
                    width: "100%",
                    height: "40px",
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "24px",
                  }}>
                  <AddNewIcon />
                </div>
                <ThemeProvider theme={theme}>
                  <Typography variant="h5" component="h2">
                    <span className="addNew">Add new payment method</span>
                  </Typography>
                </ThemeProvider>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid> */}
      </Grid>
    </Layout>
  );
};

export default PaymentGrid;
